import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    standalone: true,
    name: 'volumeDimensions',
})
export class VolumeDimensionsPipe implements PipeTransform {
    transform(
        value: number | null,
        operation: 'dimensionsToVolume' | 'volumeToDimensions',
        unitOfMeasure: 'metric' | 'imperial'
    ): number | null {
        if (value === null || value === undefined) {
            return null;
        }

        if (operation === 'dimensionsToVolume') {
            return this.dimensionsToVolume(value, unitOfMeasure);
        } else {
            return this.volumeToDimensions(value, unitOfMeasure);
        }
    }

    private dimensionsToVolume(
        dimension: number,
        unitOfMeasure: 'metric' | 'imperial'
    ): number {
        if (unitOfMeasure === 'metric') {
            const cubicCm = Math.pow(dimension, 3);
            const cubicMeters = cubicCm / 1e6;
            return Math.round(cubicMeters * 1000) / 1000;
        } else {
            const cubicInches = Math.pow(dimension, 3);
            const cubicFeet = cubicInches / 1728;
            return Math.round(cubicFeet * 1000) / 1000;
        }
    }

    private volumeToDimensions(
        volume: number,
        unitOfMeasure: 'metric' | 'imperial'
    ): number {
        if (unitOfMeasure === 'metric') {
            const cubicMeters = volume * 1e6;
            const sideInCm = Math.cbrt(cubicMeters);
            return Math.round(sideInCm * 1000) / 1000;
        } else {
            const cubicFeet = volume * 1728;
            const sideInInches = Math.cbrt(cubicFeet);
            return Math.round(sideInInches * 1000) / 1000;
        }
    }
}